<template>
    <div class="economy-learning-potential" v-if="$store.state.config.availableDepartments">
        <!--<div class="placeholder">
            <div class="placeholder__heading">
                Sammenlign afdelinger
            </div>
            <div class="placeholder padding">
                Resultatopgørelse med samme opstilling som på EBITDA fanen. I stedet for bogført, budget og afvigelse, skal der stå afdelinger i stedet og have inkl. uden afdeling.
            </div>
        </div>-->
        <div class="has-departments" v-if="$store.getters.getAvailableDepartments.length > 1">
            <div class="row">
                <div class="col-lg-12">
                    <compare-keyfigures />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <compare-revenue />
                </div>
                <div class="col-lg-6">
                    <compare-coverage-percent />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <compare-coverage />
                </div>
                <div class="col-lg-6">
                    <compare-coverage-per-hour />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <compare-customer-hours />
                </div>
            </div>
        </div>
        <div class="no-departments" v-else>
            Virksomheden har ingen afdelinger at sammenligne.
        </div>
    </div>
</template>

<script>
export default {
    components: {
        'compare-keyfigures': require('../components/compareKeyfigures'),
        'compare-revenue': require('../components/compareRevenue'),
        'compare-coverage-percent': require('../components/compareCoveragePercent'),
        'compare-coverage': require('../components/compareCoverage'),
        'compare-coverage-per-hour': require('../components/compareCoveragePerHour'),
        'compare-customer-hours': require('../components/compareCustomerHours')
    }
}
</script>



// WEBPACK FOOTER //
// compare.vue?64e9107b